import rolls from "../assets/food/rolls.webp";
import burger from "../assets/food/burger.webp";
import pizza from "../assets/food/pizza.webp";
import shake from "../assets/food/shake.webp";
import fries from "../assets/food/fries.webp";
import sandwich from "../assets/food/sandwich.webp";
import icecream from "../assets/food/icecream.webp";
import { photos } from "./photos";

// Seven dishes drive the hero themes, the home selector, the menu collection
// and the detail pages. Prices come from the current site's menu data
// (src/components/Menuall/data.js). Pizza is a promotional item without a
// menu-data price, so it points to the offers page.
export const dishes = [
  {
    id: "choco-chip-cookie-dough-rolls",
    name: "Choco Chip",
    suffix: "Cookie Dough Rolls",
    short: "Ice Cream Rolls",
    category: "Ice Cream Rolls",
    categoryBlurb: "Hand-rolled on the cold plate",
    image: rolls,
    photo: photos.rollsClose,
    colour: "#087f83",
    pale: "#e3f2ee",
    price: "₹125",
    portion: "1 plate",
    occasion: "Sweet escape",
    desc: "Chocolate-chip cookie dough, rolled fresh on the cold plate and finished with a drizzle.",
    cue: "A little joy in every roll.",
    itemRoute: "/menu/c/ice-cream-rolls",
  },
  {
    id: "veg-cheese-burger",
    name: "Veg Cheese",
    suffix: "Burger",
    short: "Burger",
    category: "Burgers",
    categoryBlurb: "Cheese and mayo, big bite",
    image: burger,
    photo: photos.burger,
    colour: "#a83c27",
    pale: "#f8e6de",
    price: "₹110",
    portion: "1 burger",
    occasion: "Big cravings",
    desc: "A generous veg patty with cheese and mayo for the days that call for a proper bite.",
    cue: "Big bites. Better moods.",
    itemRoute: "/menu/item/53",
  },
  {
    id: "cheese-pizza",
    name: "Classic",
    suffix: "Cheese Pizza",
    short: "Pizza",
    category: "Pizza",
    categoryBlurb: "Promotional item",
    image: pizza,
    photo: photos.pizzaPromo,
    colour: "#8a6200",
    pale: "#fff3cf",
    price: "See offers",
    portion: "1 pizza",
    occasion: "Share a slice",
    desc: "Cheesy slices and good company. Make a little room at the table.",
    cue: "Good times, by the slice.",
    itemRoute: "/offers",
  },
  {
    id: "dairy-milk-shake",
    name: "Dairy Milk",
    suffix: "Shake",
    short: "Shake",
    category: "Shakes",
    categoryBlurb: "Thick, cold and chocolatey",
    image: shake,
    photo: photos.shake,
    colour: "#6b4a35",
    pale: "#f1e6dc",
    price: "₹99",
    portion: "1 glass",
    occasion: "Sip & relax",
    desc: "A chocolatey café-break shake for your just-one-more-sip mood.",
    cue: "Sip into a good mood.",
    itemRoute: "/menu/item/29",
  },
  {
    id: "mr-fries",
    name: "Mr.",
    suffix: "Fries",
    short: "Fries",
    category: "Munchies",
    categoryBlurb: "Crisp, salted, shareable",
    image: fries,
    photo: photos.fries,
    colour: "#8a6200",
    pale: "#fff0c7",
    price: "₹120",
    portion: "1 portion",
    occasion: "On the side",
    desc: "A little crisp, a little comfort and something to share between bites.",
    cue: "The side of good times.",
    itemRoute: "/menu/item/44",
  },
  {
    id: "smoked-paneer-sandwich",
    name: "Smoked Paneer",
    suffix: "Sandwich",
    short: "Sandwich",
    category: "Sandwiches",
    categoryBlurb: "Grilled, toasted, warm",
    image: sandwich,
    photo: photos.sandwich,
    colour: "#075b60",
    pale: "#e1eee6",
    price: "₹110",
    portion: "1 sandwich",
    occasion: "Café catch-up",
    desc: "A toasted paneer sandwich for an easy afternoon at the café.",
    cue: "Take a well-earned break.",
    itemRoute: "/menu/item/55",
  },
  {
    id: "strawberry-sundae",
    name: "Strawberry",
    suffix: "Sundae",
    short: "Sundae",
    category: "Exotic Sundaes",
    categoryBlurb: "Crackers, jellies and cream",
    image: icecream,
    photo: photos.sundae,
    colour: "#9a3d51",
    pale: "#f6e3e8",
    price: "₹150",
    portion: "1 bowl",
    occasion: "Treat yourself",
    desc: "A cool little dessert moment to finish your visit on a sweeter note.",
    cue: "Save a little room for sweet.",
    itemRoute: "/menu/item/8",
  },
];

export const heroDishes = dishes.slice(0, 4);
export const fullName = (d) => `${d.name} ${d.suffix}`;
export const findDish = (id) => dishes.find((d) => d.id === id);

export const menuCategories = [
  { title: "Rolled", sub: "desserts" },
  { title: "Cheesy", sub: "bites" },
  { title: "Chocolatey", sub: "sips" },
  { title: "Crispy", sub: "sides" },
  { title: "Café", sub: "moments" },
];
